import { object, string, array, InferType } from 'yup';
import { AiCareDocumentOvercomeChallengeRecommendationSchema } from './AiCareDocumentOvercomeChallengeRecommendationSchema';

export const AiCareDocumentOvercomeChallengeSchema = object().shape({
  challenge: string(),
  recommendations: array().of(
    AiCareDocumentOvercomeChallengeRecommendationSchema,
  ),
  progress: string().nullable().notRequired(),
});

export type AiCareDocumentOvercomeChallenge = InferType<
  typeof AiCareDocumentOvercomeChallengeSchema
>;
